<!-- @format -->

<div
	class="availability hmf-display-flex hmf-flex-wrap hmf-justify-content-between hmf-align-items-center hmf-align-content-center"
	[class]="{ centered: !selectedStoreId }">
	@if (productAvailabilityData && !isComingSoon && !isOOS) {
		<div class="shipping-availability hmf-pb-xxxs">
			<homefield-icon
				[class]="shippingMessage?.class"
				height="10px"
				width="10px"
				[name]="shippingMessage?.icon">
			</homefield-icon>
			{{ shippingMessage?.text }}
		</div>
	}
	@if (selectedStoreId && !isComingSoon && !isOOS) {
		<div class="store-availability hmf-pb-xxxs">
			<homefield-icon
				[class]="pickupMessage?.class"
				height="10px"
				width="10px"
				[name]="pickupMessage?.icon">
			</homefield-icon>
			{{ pickupMessage?.text }}
		</div>
	}
</div>
